module.exports = "<h1>Info</h1>\r\n<p>Some text goes here</p>\r\n"